import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import classes from "../../TrucksAvailable/TrucksAvailable.module.css";
import formClasses from "./ViewLsp.module.css";
import Rating from "react-rating";
import Autosuggestor from "../../Indent/AutoComplete";
import { cloneDeep } from "lodash";
import { Urls } from "../../../Urls";
import axios from "../../../Axios";
import ProfileModal from "../../TransporterClientScreen/ProfileModal/ProfileModal";
import { addTotalTruckAllocation } from "../../../Utility";
import { closeModal } from "../InvoiceV2/utils";
import { useIndentTracking } from "../hooks/useIndentTracking";

const ViewLsp = ({
  item,
  readonly,
  planningbutton,
  setshow,
  autoAllocation = false,
}) => {
  const { trackIndentEvent } = useIndentTracking();
  const displayItem = item?.indent_info || item;
  const transporters = displayItem?.shortlisted_transporters || [];
  const rejectedCount = item?.rejected_count || 0;

  useEffect(() => {
    trackIndentEvent(
      "lorri indents",
      "user has viewed shortlisted transporter",
      `${displayItem?.origin?.location_name} to ${displayItem?.destination?.location_name}`
    );
  }, []);

  var isLanePresent =
    transporters.length > 0 &&
    transporters[0].rate === 0
      ? false
      : true;

  //   useEffect(() => {
  //     const areAllShortlisted =
  //       item.shortlisted_transporters.filter(
  //         (transporter) => transporter.is_shortlist === true
  //       ).length === item.shortlisted_transporters.length;

  //     if (areAllShortlisted) {
  //       setSelect_all(true);
  //     } else {
  //       setSelect_all(false);
  //     }
  //   }, []);

  /**
   * Toggles the `is_shortlist` status of all transporters based on the checkbox selection.
   * Updates the `select_all` state and the checkbox inputs accordingly.
   * @param {Object} e - The event object from the checkbox change.
   */
  //   const selectAll = (e) => {
  //     if (e.target.checked) {
  //       item.shortlisted_transporters.map((data, index) => {
  //         data.is_shortlist = true;
  //         document.getElementById(`checkbox${index}`).checked = true;
  //         return data;
  //       });
  //       setSelect_all(true);
  //     } else {
  //       item.shortlisted_transporters.map((data, index) => {
  //         data.is_shortlist = false;
  //         document.getElementById(`checkbox${index}`).checked = false;
  //         return data;
  //       });
  //       setSelect_all(false);
  //     }
  //   };

  return (
    <div>
      {!readonly ? (
        !isLanePresent ? (
          <NewTransporter
            item={displayItem}
            isLanePresent={isLanePresent}
            planningbutton={planningbutton}
            setshow={setshow}
          />
        ) : (
          <TransporterList
            item={displayItem}
            planningbutton={planningbutton}
            autoAllocation={autoAllocation}
          />
        )
      ) : (
        <div
          id="table-wrapper"
          className="table-wrapper"
          style={{
            height: `${
              transporters.length > 7 ? "35vh" : "auto"
            }`,
            overflowY: `${
              transporters.length > 7 ? "scroll" : "hidden"
            }`,
          }}
        >
          {transporters
            .filter((data) => (autoAllocation && rejectedCount > 0) || data.is_shortlist === true || data.is_shortlist === "true")
            .map((data, index) => (
              <div key={index} className={`${classes["s-parent-div"]}`}>
                <div className={`${classes["s-class-div"]}`}>
                  {/* <a href={`/tpmp/${encryptor(data.transporter_id, true)}`} target="_blank" rel="noopener noreferrer">{Uppercase(data.transporter_name)}</a> */}
                  <ProfileModal
                    transporter_list={transporters}
                    transporter_id={
                      planningbutton
                        ? data.transporter?.transporter_id || data.transporter_id
                        : data.transporter_id
                    }
                    transporter_name={
                      planningbutton
                        ? data.transporter?.transporter_name || data.transporter_name
                        : data.transporter_name
                    }
                    screenName={"Indents Request"}
                    moduleName={"LoRRI Indents"}
                  />
                </div>
                <div className={`${classes["s-star-div"]}`}>
                  <Rating
                    initialRating={
                      data.industry_rating
                        ? data.industry_rating.overall_rating
                        : data.overall_rating
                        ? data.overall_rating
                        : data.user_rating
                        ? data.user_rating.overall_rating
                        : 0
                    }
                    readonly={true}
                    style={{ float: "none" }}
                    emptySymbol={`fa fa-star ${classes["star-1"]}`}
                    fullSymbol={`fa fa-star ${classes["star-1-selected"]}`}
                  />
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default ViewLsp;

/**
 * Component for managing and submitting new transporter details.
 * @param {Object} props - The component props.
 * @param {Object} props.item - The item object containing details and shortlisted transporters.
 * @returns {JSX.Element} - The rendered component.
 */
const NewTransporter = ({ item, isLanePresent, planningbutton, setshow }) => {
  const [transporterText, settransporterText] = useState("");
  const [transporterList, settransporterList] = useState(
    !isLanePresent ? cloneDeep(item.shortlisted_transporters) : []
  );
  const [transit_time, settransit_time] = useState();
  const [baseline_rate, setbaseline_rate] = useState();
  const [volume, setvolume] = useState();
  const [distance, setDistance] = useState();
  const [routeCode, setRouteCode] = useState();
  const [unit, setUnit] = useState("MT");
  const [zone, setZone] = useState("");
  const [truckLoad, setTruckLoad] = useState("");
  const [contractTenure, setContractTenure] = useState("");

  /**
   * Adds a transporter to the list if it does not already exist.
   * @param {Object} e - The transporter object to add.
   * @param {number} index - The index of the transporter in the list.
   */
  const addTransporter = (e, index) => {
    let bool = false;
    var temp = transporterList;
    temp.map((items) => {
      if (e.transporter_name === items.transporter.transporter_name) {
        settransporterText("");
        bool = true;
        toast.error("Transporter Already Exist");
        return false;
      }
    });
    if (!bool) {
      temp[index].transporter = e;
      settransporterList(temp);
    }
  };

  /**
   * Updates the state of the transporter list based on input changes.
   * @param {Object} e - The event object from the input change.
   * @param {number} index - The index of the transporter in the list.
   */
  // const newInputHandler = (e, index) => {
  //   var temp = transporterList;
  //   temp[index][e.target.id] = e.target.value;
  //   settransporterList(temp);
  // };
  const newInputHandler = (e, index) => {
  const sanitizedValue = e.target.value.replace(/^-/, "");
  var temp = transporterList;
  temp[index][e.target.id] = sanitizedValue;
  settransporterList([...temp]);
  };

  /**
   * Validates and adds a new transporter to the list.
   * @param {Object} e - The event object from the button click.
   * @param {Object} data - The transporter data to validate and add.
   */
  const addNewTransporter = (e, data) => {
    const validPattern = /^[0-9.,\-]+$/;
    if (
      data.transporter.transporter_name === undefined ||
      data.rate === 0 ||
      data.business_share === 0
    ) {
      toast.error("please fill add fields");
    } else if (data.rate <= 0) {
      toast.error("Freight Rate cannot be zero or negative");
    } else if (data.business_share < 0) {
      toast.error("Business share cannot be negative");
    } else if (data.business_share % 5 !== 0) {
      toast.error("Business share should be multiples of 5");
    } else if (!validPattern.test(data.rate)) {
      alert("Please enter valid freight rate!");
    } else if (!validPattern.test(data.business_share)) {
      alert("Please enter valid business share!");
    } else {
      var last_rank = transporterList[transporterList.length - 1].rank;
      settransporterList([
        ...transporterList,
        {
          transporter: {},
          rank: last_rank + 1,
          rate: 0,
          business_share: 0,
        },
      ]);
      settransporterText("");
    }
  };

  /**
   * Checks if the sum of all business shares is equal to 100%.
   * @param {Array} lanes - The list of transporter lanes to check.
   * @returns {boolean} - True if the sum of business shares is 100%, otherwise false.
   */
  const isBusinessShareOkay = (lanes) => {
    var list = [];
    lanes.map((item) => {
      list.push(parseFloat(item.business_share));
      return item;
    });
    if (list.reduce((a, b) => a + b, 0) !== 100) {
      return false;
    } else {
      return true;
    }
  };

  /**
   * Submits the transporter data after validation and API call.
   * @param {Object} e - The event object from the submit button click.
   */
  const submitData = (e) => {
    var transporter_list = [];
    if (transporterList && transporterList.length > 0) {
      transporterList.map((item, index) => {
        item.rate = parseFloat(item.rate);
        item.business_share = parseInt(item.business_share);
        if (index !== transporterList.length - 1) {
          transporter_list.push(item);
        }
        return item;
      });
    }
    var lane = {
      origin: item.origin,
      destination: item.destination,
      truck_type: item.truck_types[0],
      volume: parseInt(volume),
      transit_time: parseInt(transit_time),
      baseline_rate: parseInt(baseline_rate),
      transporter_details: addTotalTruckAllocation(transporter_list, truckLoad),
      route_code: routeCode,
      unit: unit,
      zone: zone,
      distance: parseInt(distance),
      truck_load: truckLoad,
      contract_tenure: contractTenure,
    };
    if (isBusinessShareOkay(lane.transporter_details)) {
      const validPattern = /^[0-9.,\-]+$/;
      if (
        lane.origin.location_name === undefined ||
        lane.destination.location_name === undefined ||
        lane.truck_type.length === 0 ||
        lane.transit_time === 0 ||
        lane.baseline_rate === 0 ||
        isNaN(lane.volume) ||
        lane.volume === 0 ||
        isNaN(lane.transit_time) ||
        lane.transit_time === 0 ||
        isNaN(lane.baseline_rate) ||
        lane.baseline_rate === 0 ||
        lane.transporter_details.length === 0
      ) {
        toast.error("Please fill all fields");
        return false;
      } else if (!validPattern.test(lane.volume)) {
        toast.error("Please enter valid volume!");
        return false;
      } else if (!validPattern.test(lane.transit_time)) {
        toast.error("Please enter valid transit time!");
        return false;
      } else if (!validPattern.test(lane.baseline_rate)) {
        toast.error("Please enter valid baseline rate!");
        return false;
      } else if (!validPattern.test(lane.distance)) {
        toast.error("Please enter valid Distance!");
        return false;
      } else if (lane.volume < 0) {
        toast.error("Volume cannot be negative");
        return false;
      } else if (!validPattern.test(lane.truck_load)) {
        toast.error("Please enter valid truck load!");
        return false;
      } else if (
        lane.contract_tenure === "" ||
        lane.contract_tenure === undefined
      ) {
        toast.error("Please enter valid contract tenure!");
        return false;
      } else if (lane.transit_time < 0) {
        toast.error("Transit Time cannot be negative");
        return false;
      } else if (lane.baseline_rate < 0) {
        toast.error("Baseline Rate cannot be negative");
        return false;
      } else if (lane.distance < 0) {
        toast.error("Distance cannot be negative");
        return false;
      } else {
        setshow(true);
        if (lane.transporter_details && lane.transporter_details.length > 0) {
          lane.transporter_details.map((lsps) => {
            return (lsps.rank = `L${lsps.rank}`);
          });
        }
        axios
          .post(
            `${Urls.freight_master}`,
            { lanes: [lane] },
            { skipInterceptorToast: true }
          )
          .then((res) => {
            const data = res?.data;
            if (data?.status === "failed" && data?.id?.exist === true) {
              setshow(false);
              toast.error(
                "Route code already in use — it's assigned to a different origin-destination pair. Please use a unique route code or update the Route Master."
              );
              return;
            }

            toast.success("Transporter shortlisted successfully");

            var list = [];
            if (transporterList && transporterList.length > 0) {
              transporterList.map((item, index) => {
                if (index !== transporterList.length - 1) {
                  var temp = item.transporter;
                  temp["rank"] = item.rank;
                  temp["business_share"] = item.business_share;
                  temp["rate"] = item.rate;
                  list.push(temp);
                }
                return item;
              });
            }

            if (list && list.length > 0) {
              list.map((data, index) => {
                data.is_shortlist = true;
                return data;
              });
            }
            item.shortlisted_transporters = list;
            item.freightid = res.data.id;

            closeModal();
            setshow(false);
          })
          .catch((err) => {
            console.log(err);
            setshow(false);
            const data = err?.response?.data;
            if (data?.status === "failed" && data?.id?.exist === true) {
              toast.error(
                "Route code already in use — it's assigned to a different origin-destination pair. Please use a unique route code or update the Route Master."
              );
            } else {
              toast.error("Failed to shortlist transporter. Please try again.");
            }
          });
      }
    } else {
      toast.error("Please make sure total business share is 100%");
    }
  };

  /**
   * Deletes a transporter from the list and reorders the ranks.
   * @param {number} index - The index of the transporter to delete.
   */
  const deleteTransporter = (index) => {
    const temp = [...transporterList];
    var list = [];
    var rankCounter = 1;
    const itemRemove = temp.splice(index, 1);
    if (temp && temp.length > 0) {
      temp.map((item) => {
        if (item.rank !== itemRemove.rank) {
          item.rank = rankCounter++;
          list.push(item);
        }
      });
    }
    settransporterList(list);
  };

  return (
    <div>
      <div className={formClasses.heading}>
        Lane{" "}
        {planningbutton
          ? item.origin.location_name
          : item.origin.location.location}{" "}
        to{" "}
        {planningbutton
          ? item.destination.location_name
          : item.destination.location.location}{" "}
        is not present in your Freight Master
      </div>
      <div className={formClasses.subheading}>
        Kindly provide the following details to proceed
      </div>

      <div className={formClasses.formGrid}>
        <div className={formClasses.field}>
          <label className={formClasses.label} htmlFor="volume">
            Volume<span className={formClasses.required}>*</span>
          </label>
          <input
            className={formClasses.input}
            type="number"
            name="volume"
            id="volume"
            placeholder="0"
            onChange={(e) => setvolume(e.target.value.replace(/^-/, ""))}
            value={volume}
          />
        </div>

        <div className={formClasses.field}>
          <label className={formClasses.label} htmlFor="transit_time">
            Transit Time<span className={formClasses.required}>*</span>
          </label>
          <input
            className={formClasses.input}
            type="number"
            name="transit_time"
            id="transit_time"
            placeholder="0"
            onChange={(e) => settransit_time(e.target.value.replace(/^-/, ""))}
            value={transit_time}
          />
        </div>

        <div className={formClasses.field}>
          <label className={formClasses.label} htmlFor="baseline_rate">
            Baseline Rate<span className={formClasses.required}>*</span>
          </label>
          <input
            className={formClasses.input}
            type="number"
            name="baseline_rate"
            id="baseline_rate"
            placeholder="0"
            onChange={(e) => setbaseline_rate(e.target.value.replace(/^-/, ""))}
            value={baseline_rate}
          />
        </div>

        <div className={formClasses.field}>
          <label className={formClasses.label} htmlFor="distance">
            Distance<span className={formClasses.required}>*</span>
          </label>
          <input
            className={formClasses.input}
            type="number"
            name="distance"
            id="distance"
            placeholder="0"
            onChange={(e) => setDistance(e.target.value.replace(/^-/, ""))}
            value={distance}
          />
        </div>

        <div className={formClasses.field}>
          <label className={formClasses.label} htmlFor="zone">
            Zone<span className={formClasses.required}>*</span>
          </label>
          <input
            className={formClasses.input}
            type="text"
            name="zone"
            id="zone"
            placeholder="Enter Zone"
            onChange={(e) => setZone(e.target.value)}
            value={zone}
          />
        </div>

        <div className={formClasses.field}>
          <label className={formClasses.label} htmlFor="route_code">
            Route Code
          </label>
          <input
            className={formClasses.input}
            type="text"
            name="route_code"
            id="route_code"
            placeholder="Enter Route Code"
            onChange={(e) => setRouteCode(e.target.value)}
            value={routeCode}
          />
        </div>

        <div className={formClasses.field}>
          <label className={formClasses.label}>Unit</label>
          <select
            className={formClasses.select}
            onChange={(e) => setUnit(e.target.value)}
            defaultValue={unit}
          >
            <option value="MT">MT</option>
            <option value="KG">KG</option>
          </select>
        </div>

        <div className={formClasses.field}>
          <label className={formClasses.label}>
            Contract Tenure<span className={formClasses.required}>*</span>
          </label>
          <select
            className={formClasses.select}
            onChange={(e) => setContractTenure(e.target.value)}
            defaultValue=""
          >
            <option value="" hidden>Select contract tenure</option>
            <option value="Annual">Annual</option>
            <option value="Semi-annual">Semi Annual</option>
            <option value="Monthly">Monthly</option>
            <option value="Weekly">Weekly</option>
          </select>
        </div>

        <div className={formClasses.field}>
          <label className={formClasses.label} htmlFor="truck_load">
            Truck Load<span className={formClasses.required}>*</span>
          </label>
          <input
            className={formClasses.input}
            type="number"
            name="truck_load"
            id="truck_load"
            placeholder="Enter truck load"
            onChange={(e) => setTruckLoad(e.target.value.replace(/^-/, ""))}
            value={truckLoad}
          />
        </div>
      </div>

      <hr className={formClasses.divider} />

      {transporterList.length > 0 ? (
        <div className={formClasses.transporterTable}>
          {transporterList.map((data, index) => (
            <div
              key={index}
              className={`${formClasses.transporterRow} ${index !== transporterList.length - 1 ? formClasses.transporterRowStatic : ""
                }`}
            >
              {index === transporterList.length - 1 ? (
                <>
                  <div className={`${formClasses.field} ${formClasses.transporterCol}`}>
                    <label className={formClasses.label}>
                      Transporter<span className={formClasses.required}>*</span>
                    </label>
                    <div className={formClasses.autosuggestScope}>
                      <Autosuggestor
                        value={transporterText}
                        onChange={(e) => settransporterText(e)}
                        onSelect={(e) => settransporterText(e)}
                        getResults={(e) => addTransporter(e, index)}
                      />
                    </div>
                  </div>
                  <div className={`${formClasses.field} ${formClasses.typeCol}`}>
                    <label className={formClasses.label}>Type</label>
                    <span className={formClasses.rankBadge}>
                      {data.rank && typeof data.rank === "string"
                        ? data.rank.replace(/L(?!.*L)/g, "") === data.rank
                          ? `L${data.rank}`
                          : data.rank
                        : `L${data.rank}`}
                    </span>
                  </div>
                  <div className={`${formClasses.field} ${formClasses.shareCol}`}>
                    <label className={formClasses.label}>
                      Business Share<span className={formClasses.required}>*</span>
                    </label>
                    <input
                      className={formClasses.input}
                      type="number"
                      id="business_share"
                      placeholder="0"
                      onChange={(e) => newInputHandler(e, index)}
                      defaultvalue={transporterList[index].business_share}
                    />
                  </div>
                  <div className={`${formClasses.field} ${formClasses.shareCol}`}>
                    <label className={formClasses.label}>
                      Freight<span className={formClasses.required}>*</span>
                    </label>
                    <input
                      className={formClasses.input}
                      type="number"
                      id="rate"
                      placeholder="0"
                      onChange={(e) => newInputHandler(e, index)}
                      defaultvalue={transporterList[index].rate}
                    />
                  </div>
                  <button
                    type="button"
                    className={formClasses.actionButton}
                    title="Add transporter"
                    onClick={(e) => addNewTransporter(e, data)}
                  >
                    <i className="fa fa-plus" />
                  </button>
                </>
              ) : (
                <>
                  <div className={`${formClasses.field} ${formClasses.transporterCol}`}>
                    <label className={formClasses.label}>Transporter</label>
                    <span className={formClasses.staticValue}>
                      {data.transporter.transporter_name}
                    </span>
                  </div>
                  <div className={`${formClasses.field} ${formClasses.typeCol}`}>
                    <label className={formClasses.label}>Type</label>
                    <span className={formClasses.rankBadge}>L{data.rank}</span>
                  </div>
                  <div className={`${formClasses.field} ${formClasses.shareCol}`}>
                    <label className={formClasses.label}>Business Share</label>
                    <span className={formClasses.staticValue}>
                      {data.business_share}%
                    </span>
                  </div>
                  <div className={`${formClasses.field} ${formClasses.shareCol}`}>
                    <label className={formClasses.label}>Freight</label>
                    <span className={formClasses.staticValue}>{data.rate}</span>
                  </div>
                  <button
                    type="button"
                    className={formClasses.deleteButton}
                    title="Remove transporter"
                    onClick={() => deleteTransporter(index)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </>
              )}
            </div>
          ))}
        </div>
      ) : null}

      <div className={formClasses.submitWrap}>
        <button className={formClasses.submitButton} onClick={(e) => submitData(e)}>
          Submit
        </button>
      </div>
    </div>
  );
};

const TransporterList = ({ item, planningbutton, autoAllocation }) => {
  const [localTransporters, setLocalTransporters] = useState([]);
  const { trackIndentEvent } = useIndentTracking();

  const normalizeTransporters = useCallback(
    (transporters = []) =>
      transporters.map((lsp) => ({
        ...lsp,
        is_shortlist:
          lsp.is_shortlist === true ||
          lsp.is_shortlist === "true" ||
          lsp.selected === true,
      })),
    []
  );

  useEffect(() => {
    setLocalTransporters(
      normalizeTransporters(item?.shortlisted_transporters || [])
    );
  }, [item, normalizeTransporters]);

  /**
   * Toggles the `is_shortlist` status of a transporter in the local list
   * @param {Object} e - The event object from the user interaction.
   * @param {Object} data - The transporter object whose `is_shortlist` status is toggled.
   */
  const getTransporterId = useCallback(
    (transporter) =>
      planningbutton && transporter?.transporter
        ? transporter.transporter.transporter_id
        : transporter?.transporter_id,
    [planningbutton]
  );

  const getTransporterName = (transporter) =>
    planningbutton && transporter?.transporter
      ? transporter.transporter.transporter_name
      : transporter?.transporter_name;

  const check_selection = (data) => {
    const id = getTransporterId(data);
    const updatedTransporters = localTransporters.map((transporter) =>
      getTransporterId(transporter) === id
        ? { ...transporter, is_shortlist: !transporter.is_shortlist }
        : transporter
    );
    setLocalTransporters(updatedTransporters);
  };

  const transporterSubmit = () => {
    const selectedTransporters = localTransporters.filter(
      (data) => data.is_shortlist === true
    );

    trackIndentEvent(
      "lorri indents",
      "user has shortlisted transporters",
      `${item?.origin?.location_name ?? "NA"} to ${
        item?.destination?.location_name ?? "NA"
      }`
    );

    if (selectedTransporters.length > 0) {
      item.shortlisted_transporters = selectedTransporters;

      toast.success("Transporters shortlisted successfully");
      closeModal();
    } else {
      toast.info("Please select transporters and click on submit");
    }
  };

  return (
    <div id="table-wrapper" className="table-wrapper">
      {localTransporters
        ?.filter(
          (data, index, self) =>
            self.findIndex((t) => getTransporterId(t) === getTransporterId(data)) ===
           index
        )
        ?.map((data, index) => {
          const {
            rank,
            business_share,
            industry_rating,
            overall_rating,
          } = data;

          const transporter_id = getTransporterId(data);
          const transporter_name = getTransporterName(data);

          const finalRating = industry_rating
            ? industry_rating.overall_rating
            : overall_rating;

          const formattedRank =
            rank && typeof rank === "string"
              ? rank.includes("L")
                ? `${rank.replace(/L(?=.*L)/g, "")} (${business_share}%)`
                : `L${rank} (${business_share}%)`
              : `L${rank} (${business_share}%)`;

          return (
            <div key={index} className={classes["s-parent-div"]}>
              <div className={classes["s-class-div"]}>
                <input
                  id={`checkbox${index}`}
                  className={classes["s-checkbox"]}
                  type="checkbox"
                  onChange={() => check_selection(data)}
                  checked={data.is_shortlist} // Use checked instead of defaultChecked for controlled behavior
                  disabled={autoAllocation}
                />
                <ProfileModal
                  transporter_list={localTransporters}
                    transporter_name={transporter_name}
                    transporter_id={transporter_id}
                  screenName={"Indent Request"}
                  moduleName={"LoRRI Indents"}
                />
              </div>
              <div
                className={classes["s-type-div"]}
                title="Rank & Share of Business"
              >
                {formattedRank}
              </div>
              <div className={classes["s-star-div"]}>
                <Rating
                  initialRating={finalRating}
                  readonly={true}
                  style={{ float: "none" }}
                  emptySymbol={`fa fa-star ${classes["star-1"]}`}
                  fullSymbol={`fa fa-star ${classes["star-1-selected"]}`}
                />
              </div>
            </div>
          );
        })}

      {autoAllocation && (
        <div className="my-3 text-italic text-sm">
          <em>
            NOTE : <u>Indent Auto Allocation</u> is <strong>ON</strong>. Indent(s) will be automatically assigned to above
            transporters based on their Share of Business (SOB) as per
            Freight Master.
          </em>
        </div>
      )}

      <div style={{ textAlign: "center", marginTop: "2%" }}>
        <button className="btn btn-success" onClick={transporterSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
};
